<template>
  <div class="payList-container">
    <div class="payList-tab">
      <img @click="handleBack" style="width: 24px; height: 24px" src="../assets/back.png" />
      <div>工资条</div>
    </div>
    <div class="payList-info">
      <img :src="mineInfo.avatar" style="width: 1.07rem;height: 1.07rem;margin-left: 0.37rem;border-radius: 0.11rem;" />
      <div style="margin-left:0.24rem;">
        <div style="font-size: 0.43rem;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #333333;">姓名：{{mineInfo.userName}}</div>
        <div style="font-size: 0.32rem;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #999999;">部门：{{mineInfo.officeName}}</div>
      </div>
    </div>
    <div class="payList-list" v-for="(item,index) in payList" :key="index">
      <div style="margin-bottom: 0.27rem;font-size: 0.37rem;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #999999;">
        {{item[0].year + '年'}}
      </div>
      <van-field
        v-for="(i,index1) in item" 
        :key="index1"
        style="width: 9.25rem;height: 1.33rem;font-size: 0.37rem;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #333333;"
        is-link readonly
        :value="`${i.month}月工资条`"
        @click="handleClick(i)"
      >
      </van-field>
    </div>
  </div>
</template>

<script>
import { queryPayList, getMineInfo } from '../axios/services'
import { mapState } from "vuex";
import { Toast } from 'vant';
export default {
  data() {
    return {
      payList: [],
      mineInfo: {}
    }
  },
  computed: {
    ...mapState(['initialData'])
  },
  methods: {
    handleBack() {
      window.location.href = "jsToOc://back";
    },
    handleClick(item) {
      this.$store.commit('setPayDate',item)
      this.$router.push('/pay-slip');
    }
  },
  created() {
    const params = {
      companyId: this.initialData.companyId
    };
    getMineInfo().then(res => {
      if(res.data.code === 0) {
        this.mineInfo = res.data.data
      }else {
        Toast.fail(res.data.msg)
      }
    })
    queryPayList(params).then(res => {
      if(res.data.code === 0) {
        this.payList = Object.values(res.data.data?.reduce((res, item) => {
        res[item.year] ? res[item.year].push(item) : res[item.year] = [item];
          return res;
        }, {})).reverse();
      }else {
        Toast.fail(res.data.msg)
      }
    })
  }
}
</script>

<style scoped>
  .payList-container {
    width: 100%;
    height: 100%;
    position: relative;
    padding-top: 1.71rem;
  }
  .payList-tab {
    width: 10rem;
    height: 1.71rem;
    background: #FFFFFF;
    position: fixed;
    z-index: 99;
    padding-left: 0.43rem;
    line-height: 1.71rem;
    top:0;
    left:0;
  }
  .payList-tab div {
    font-size: 0.48rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .payList-info {
    width: 10rem;
    height: 1.92rem;
    background: #FFFFFF;
    margin-top: 0.37rem;
    display: flex;
    align-items: center;
  }
  .payList-list {
    width: 9.25rem;
    margin: 0.53rem auto;
  }
</style>